import React, { useState } from "react";
import {
  Button,
  IconButton,
  Card,
  CardActions,
  CardContent,
  Collapse,
  CardHeader,
  Grow,
  CircularProgress,
  LinearProgress,
  TableContainer
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import SaveIcon from "@material-ui/icons/Save";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import DeleteIcon from "@material-ui/icons/Delete";
import DeleteIconInPlatform from "@material-ui/icons/RestoreFromTrash";
import LockIcon from "@material-ui/icons/LockRounded";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { useForm } from 'react-hook-form';
import IntegrationsService from '../../../../../../../../services/IntegrationsService';
import actionsTopButtonStyles from '../../../../../../../components/App/customMaterialStyles';
import { useDispatch, useSelector } from "react-redux";
import { showSnackBar } from "../../../../../../../../redux/actions/ui";
import IntegrationForm from "./IntegrationForm";
import { showConfirmDialog } from "../../../../../../../../redux/actions/uiConfirmDialog";
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ModalRunSync from "../modals/modalRunSync";


const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: "1em"
  },
  collapse: {
    borderTop: "1px solid"
  },
  TableContainer: {
    maxHeight: 440,
  },
}));

function IntegrationItem(props) {
  const { loading = false } = props;  
  const dispatch = useDispatch();
  const { user } = useSelector( state => state );
  
  const { id, domain, integration_backend, is_authorized, authorization_url, status, sync_get_time, sync_post_time, last_execution_summary } = props.data || {};
  
  const classes = useStyles();
  const actionsTopButtonStylesClasses = actionsTopButtonStyles();

  const [expanded, setExpanded] = useState(false);
  const [expandedSummary, setExpandedSymmary] = useState(false);
  const [isEditableForm, setIsEditableForm] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isLoadingTerms, setIsLoadingTerms] = useState(false);
  const [openModalRunSync, setOpenModalRunSync] = useState(false);
  const [terms, setTerms] = useState([]); 
  const isCanvas = integration_backend === "CANVAS";
  const showTitle = isCanvas ? true : false;


  const { register, errors, handleSubmit, control, getValues, watch  } = useForm({
    validateCriteriaMode: "all",
    mode: "onChange"
  });
  
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleExpandSummaryClick = () => {
    setExpandedSymmary(!expandedSummary);
  };


  const handleClickCloseModalRunSync = () => {
    setOpenModalRunSync(false);
  };
  
  const handleClickOpenDialogRemove = () => {
    dispatch(
      showConfirmDialog(
        "Remove this Integration ?", 
        "You won't be able to revert this!", 
        handleOnDelete
      )
    );
  };

  const handleOnDelete = async () => {    
    setIsLoadingSubmit(true);
    try{
      const integrationID = id;
      await IntegrationsService.deleteIntegration(integrationID);         
      // handleCloseDialogRemove();
      props.removeIntegration(integrationID);
    }catch (error) {
      setIsLoadingSubmit(false);
    }  
  }

  const handleOnSendData = async () => {    
    setIsLoadingSubmit(true);
    try{
      const integrationID = id;
      await IntegrationsService.syncSentIntegration(integrationID);
      setIsLoadingSubmit(false);      
      dispatch(showSnackBar("Starting Sync!"));
    }catch (error) {
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }      
    setIsLoadingSubmit(false);
  }

  const handleOnGetData = async () => {
    setIsLoadingTerms(true);
    dispatch(showSnackBar("Starting sync!"));
    try{
      await IntegrationsService.syncGetIntegration(id, []);
      setIsLoadingTerms(false);      
    }catch (error) {
      setIsLoadingTerms(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }
  }

  const handleOnGetDataCanvas = async () => {    
    setIsLoadingTerms(true);
    try{
      // const integrationID = id;
      // await IntegrationsService.syncGetIntegration(integrationID);
      setOpenModalRunSync(true);
      const result = await IntegrationsService.retrieveCanvasTerms(
        id,
        {
          fields: "id,first_name,last_name",
          limit: 'no_paginate'
        }
      );            
      setTerms(result.data.results);
      setIsLoadingTerms(false);      
      // dispatch(showSnackBar("Starting Sync!"));
    }catch (error) {
      setIsLoadingTerms(false);
      setTerms([]);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }      
    setIsLoadingTerms(false);
  }

  const handleOnDeleteData = async () => {    
    setIsLoadingSubmit(true);
    try{
      const integrationID = id;
      await IntegrationsService.deleteInFlo(integrationID);
      setIsLoadingSubmit(false);      
      dispatch(showSnackBar("Starting deletion!"));
    }catch (error) {
      console.log(error)
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }      
    setIsLoadingSubmit(false);
  }

  const handleOnDeleteDataInPlatform = async () => {    
    setIsLoadingSubmit(true);
    try{
      const integrationID = id;
      await IntegrationsService.deleteInIntegration(integrationID);
      setIsLoadingSubmit(false);      
      dispatch(showSnackBar("Starting deletion!"));
    }catch (error) {
      console.log(error)
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }      
    setIsLoadingSubmit(false);
  }
  
  const editIntegration = async data => {    
    const dataToUpdate = {...data, id};    
    setIsLoadingSubmit(true);
    try{
      await IntegrationsService.updateIntegration(dataToUpdate);
      setIsLoadingSubmit(false);      
      dispatch(showSnackBar("Successfully edited!"));
      if(domain !== dataToUpdate.domain || integration_backend !== dataToUpdate.integration_backend){
        // if the name changed we need to update the list
        props.updateIntegrationFromList();
      }
    }catch (error) {
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
    }  
  };


  return (
    <Card className={classes.root}>
      {/* Integration header */}
      <CardHeader
        action={
          <React.Fragment >
            {expanded && (
              <React.Fragment>
                <Grow in={expanded} {...(expanded ? { timeout: 1000 } : {})}>                
                  <IconButton 
                    aria-label="edit-integration" 
                    className={clsx(actionsTopButtonStylesClasses.actionsTopButtons, {
                      [actionsTopButtonStylesClasses.actionsTopButtonsSelected]: isEditableForm
                    }) } 
                    onClick={() => setIsEditableForm(!isEditableForm) }>
                    <EditOutlinedIcon />
                  </IconButton>
                </Grow>    
                {user && user.data.profile === 'manager' ?
                <Grow in={expanded} {...(expanded ? { timeout: 500 } : {})} >
                  <IconButton aria-label="delete-integration" className={actionsTopButtonStylesClasses.actionsTopButtons} onClick={handleClickOpenDialogRemove}>
                    <DeleteForeverOutlinedIcon />
                  </IconButton>
                </Grow>
                : null}
              </React.Fragment>
            )}

            {loading ?
              <Skeleton
                variant="circle"
                width={50}
                height={50}
                style={{ marginBottom: 0 }}
              />
              :
              <IconButton
                className={clsx(actionsTopButtonStylesClasses.expand, {
                  [actionsTopButtonStylesClasses.expandOpen]: expanded
                }, actionsTopButtonStylesClasses.actionsTopButtons)}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="Expand"
                data-testid="expand-integration"
              >
                <ExpandMoreIcon />
              </IconButton>              
            }
          </React.Fragment>
        }
        title={
          loading ? (
            <Skeleton
              variant="rect"
              width={180}
              height={20}
              style={{ marginBottom: 6 }}
            />
          ) : (
            `${integration_backend} - ${showTitle ? domain: ''} ${is_authorized ? '(Authorized)' : '(Not Authorized)'}` 
          )
        }
        subheader={
          loading ? (
            <Skeleton variant="rect" width={210} height={10} />            
          ) : (
            <React.Fragment>              
              Status: {status}
              {sync_get_time  ? <React.Fragment><br/>Sync Read Time: {sync_get_time}</React.Fragment> : null}
              {sync_post_time  ? <React.Fragment><br/>Sync Write Time: {sync_post_time}</React.Fragment> : null}
            </React.Fragment>
          )
        }
      />
      
      {/* Loading */}
      {isLoadingSubmit && <LinearProgress />}      

      {/* Body forms */}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className={classes.collapse}>
          <IntegrationForm isEditableForm={isEditableForm} data={props.data} formConfig={ {register, errors, handleSubmit, control, getValues, watch } }>
            {/* Authorize Buttons to save */}
            {!is_authorized ? (
              <CardActions className={actionsTopButtonStylesClasses.saveActionLeft} >
                <Button
                  component="a"
                  href={authorization_url}
                  target="_parent"
                  variant="outlined"
                  color="primary"
                  startIcon={<LockIcon/>}>
                      Authorize
                 </Button>
              </CardActions> 
            ) : (
              <CardActions className={actionsTopButtonStylesClasses.saveActionLeft} >
                <Button
                  onClick={handleOnSendData}
                  variant="outlined"
                  color="primary"
                  startIcon={<ArrowUpwardIcon/>}>
                      Send data
                 </Button>

                 <Button
                  onClick={isCanvas ? handleOnGetDataCanvas : handleOnGetData}
                  variant="outlined"
                  color="primary"
                  disabled={isLoadingTerms}
                  startIcon={<ArrowDownwardIcon/>}>
                      Get data
                 </Button>

                 <Button
                  onClick={handleOnDeleteData}
                  variant="outlined"
                  color="primary"
                  startIcon={<DeleteIcon/>}>
                      Delete Data in Flo
                 </Button>

                 <Button
                  onClick={handleOnDeleteDataInPlatform}
                  variant="outlined"
                  color="primary"
                  startIcon={<DeleteIconInPlatform/>}>
                      Delete In platform
                 </Button>
              </CardActions> 
            )}

            {/* Action Buttons to save */}
            {isEditableForm && (
              <React.Fragment>              
                <CardActions className={actionsTopButtonStylesClasses.saveAction} >
                  <Button
                    variant="outlined"
                    type="submit"
                    disabled={isLoadingSubmit} 
                    onClick={() => setIsEditableForm(false)}>
                    Cancel
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"     
                    type="submit"            
                    onClick={handleSubmit(editIntegration)}
                    disabled={isLoadingSubmit} 
                    startIcon={
                      isLoadingSubmit ? <CircularProgress size={24}/> : <SaveIcon />
                    }>
                    Save
                  </Button>
                </CardActions>
              </React.Fragment>
            )} 
            <div>
              {last_execution_summary && Object.keys(last_execution_summary).length > 0 && (
                <Button
                  onClick={handleExpandSummaryClick}
                  aria-expanded={expandedSummary}
                  aria-label="Expand"
                  variant="outlined"
                  color="primary"
                  data-testid="expand-summary"
                >
                  Summary data ({expandedSummary ? "Close": "Open"} {last_execution_summary ? last_execution_summary.action : ""})
                </Button>      
              )}
            </div>
                
            {last_execution_summary &&  Object.keys(last_execution_summary).length > 0 &&  expandedSummary && (
              <React.Fragment>                                      
                <TableContainer className={classes.TableContainer}>
              <Table stickyHeader aria-label="sticky simple table" size="small" >                                
                <TableHead>                      
                        <TableRow>
                          <TableCell component="th" scope="row">
                              Platform ID
                          </TableCell>
                          <TableCell component="th" scope="row">
                              Platform Element
                          </TableCell>
                          <TableCell component="th" scope="row">
                              Item id
                          </TableCell>
                          <TableCell component="th" scope="row">
                              Item Element
                          </TableCell>
                          <TableCell component="th" scope="row">
                              Action
                          </TableCell>
                        </TableRow>          
                </TableHead>

                <TableBody>       
                    {last_execution_summary.errors.map((i, count) => 
                    <TableRow key={`${i.integration_id}_${i.model_id}_errors_${count}` }>
                        <TableCell component="th" scope="row">
                          {i.integration_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.integration_element}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.model_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.model_element}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          Error: 
                          {i.error}
                        </TableCell>
                    </TableRow>   
                      )}            
        
                    {last_execution_summary.created.map((i, count) => 
                    <TableRow key={`${i.integration_id}_${i.model_id}_created_${count}` }>
                        <TableCell component="th" scope="row">
                          {i.integration_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.integration_element}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.model_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.model_element}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          Created
                        </TableCell>
                    </TableRow>   
                      )} 
                    
                    {last_execution_summary.updated.map((i, count)=>                     
                    <TableRow key={`${i.integration_id}_${i.model_id}_updated_${count}` }>                        
                        <TableCell component="th" scope="row">
                          {i.integration_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.integration_element}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.model_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.model_element}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          Updated
                        </TableCell>
                    </TableRow>   
                      )} 

                  {last_execution_summary.removed.map((i, count)  => 
                    <TableRow key={`${i.integration_id}_${i.model_id}_removed_${count}` }>
                        <TableCell component="th" scope="row">
                          {i.integration_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.integration_element}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.model_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {i.model_element}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          Removed
                        </TableCell>
                    </TableRow>   
                      )} 
                  
                  
                </TableBody>

              </Table>
              </TableContainer>
              </React.Fragment>
            )}



          </IntegrationForm>
        </CardContent>
      </Collapse>

      {/* Modal Dialog for Remove Data */}
      <ModalRunSync
        open={openModalRunSync}
        onClose={handleClickCloseModalRunSync}
        integrationId={id}        
        terms={terms}
        isLoadingTerms={isLoadingTerms}
        updateIntegrationFromList={props.updateIntegrationFromList}
      />
      
    </Card>
  );
}

export default IntegrationItem;
